import ApiConstants from '../constants/ApiConstants';
import Utility from '../utility/Utility';
import http from "../http";

export interface BenefitListAPIConfig {
    // SearchTerm?: string;
    Limit?: number;
    query?:string;
    sort_order?:string;
    currentPage?:string;
    field? :string;
    CurrentPage?: number;
    isHidden?:string;
}

const defaultConfig: BenefitListAPIConfig = {
    Limit: 10,
    currentPage: '1',
    sort_order: 'desc',
    field: '_id',
    isHidden: 'false'
};

class BenefitService {
    static apiConfig: BenefitListAPIConfig;

    static getBenefitBypage() {
        if (Utility.isEmpty(this.apiConfig)) {
            this.apiConfig = defaultConfig;
        }
        const url = ApiConstants.URL.BASE+ApiConstants.URL.PEOPLE.COMPONENT+'benefits/tenant';
        return http
            .get(
                `${url}?limit=${this.apiConfig.Limit}&currentPage=${this.apiConfig.currentPage}&sort_order=${this.apiConfig.sort_order}&sort_field=${this.apiConfig.field}`
            )
            .catch((err: any) => {
                console.error('Error loading component: ', err);
                return Promise.reject(err);
            });
    }

    static getTotalBenefit() {
        const url = ApiConstants.URL.PEOPLE.COMPONENT+'benefits/tenant';
        return http.get(url);
    }

}

export default BenefitService;
